export default __webpack_public_path__ + "static/media/first.33a25282.jpg";